import { type DropdownItem } from '@/forms-legacy'
import { useMemo } from 'react'
import { useTexts } from './useTexts'

export function useOptions() {
  const texts = useTexts()

  return useMemo<DropdownItem[]>(() => {
    return optionsId.map(id => {
      switch (id) {
        case 'NEVER':
          return { id, label: texts.never }
        case 'AFTER_NUMBER':
          return { id, label: texts.afterNumber }
        case 'ON_DATE':
          return { id, label: texts.onDate }
      }
    })
  }, [texts])
}

const optionsId = ['NEVER', 'AFTER_NUMBER', 'ON_DATE'] as const
